import axios from "axios";

const url = process.env.REACT_APP__BASE_URL;

const FixedAgent = {
  getProductList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/product/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getAllAgents: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/fixedagent/list`,
      method: "POST",
      params: {
        page: payload.page || payload.page_no || 1,
        per_page: payload.perPage || payload.per_page || 25,
        ...(payload.search ? { search: payload.search } : {}),
      },
      data: payload.search ? { search: payload.search } : {},
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerByPlateNumber: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerOnlineData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/online/data/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCreditHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/wallet/credit/list`,
      method: "GET",
      params: {
        page: payload.page || payload.page_no || 1,
        per_page: payload.perPage || payload.per_page || 25,
        ...(payload.search ? { search: payload.search } : {}),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getDebitHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/fixedagent/fund/history`,
      method: "GET",
      params: {
        page: payload.page || payload.page_no || 1,
        per_page: payload.perPage || payload.per_page || 25,
        ...(payload.search ? { search: payload.search } : {}),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getOrderHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/orders`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  addNewAgent: (payload) => {
    const response = axios({
      url: `${url}/app/auth/distributor/register/fixedagent`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        phone_no: payload.phone_no,
        business_name: payload.business_name,
        password: payload.password,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  fundAgent: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/fixedagent/fundwallet`,
      method: "POST",
      data: JSON.stringify({
        fixedagent_id: payload.fixedagent_id,
        amount: payload.amount,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getPinList: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/list`,
      method: "GET",
      params: {
        page: payload.page || 1,
        ...(payload.status ? { status: payload.status } : {}),
        ...(payload.platform ? { platform: payload.platform } : {}),
        ...(payload.type ? { type: payload.type } : {}),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNewPinList: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/list`,
      method: "GET",
      params: {
        page: payload.page || 1,
        ...(payload.status ? { status: payload.status } : {}),
        ...(payload.platform ? { platform: payload.platform } : {}),
        ...(payload.type ? { type: payload.type } : {}),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  sellPin: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/sell`,
      method: "POST",
      data: JSON.stringify({
        count: payload.count,
        fixedagent_email: payload.fixedagent_email,
        export_option: payload.export_option,
        pin_type: payload.pin_type,
        type: payload.type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNewExportedPin: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/get-sales-exported-details-by-id/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  clearInvoice: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/clear-invoice/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newSellPin: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/sell`,
      method: "POST",
      data: JSON.stringify({
        count: payload.count,
        fixedagent_email: payload.fixedagent_email,
        export_option: payload.export_option,
        pin_type: payload.pin_type,
        type: payload.type,
        unit_price: payload.unit_price,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getPrice: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/get-price/${payload.pinType}/${payload.type}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  fetchPinPriceSpreadsheet: (payload) => {
    const response = axios({
      url: payload.sheetUrl,
      method: "GET",
      responseType: "text",
      transformResponse: [(data) => data],
    });
    return response;
  },

  exportPins: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/export/${payload.count}/${payload.pinType}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newExportPins: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/export/${payload.count}/${payload.pinType}/${payload.type}/${payload.email}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  boughtListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/bought-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newBoughtListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/new-bought-list`,
      method: "GET",
      params: { page: payload.page || 1, ...(payload.search ? { search: payload.search } : {}) },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newExportedPinsHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/exported-pin-list`,
      method: "GET",
      params: { page: payload.page || 1, ...(payload.search ? { search: payload.search } : {}) },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },
  soldListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/sold-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newSoldListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/new-sold-list`,
      method: "GET",
      params: { page: payload.page || 1, ...(payload.search ? { search: payload.search } : {}) },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getUsedSoldPinList: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/used-sold-list`,
      method: "GET",
      params: { page: payload.page || 1, ...(payload.search ? { search: payload.search } : {}) },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getActiveSoldPinList: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/active-sold-list`,
      method: "GET",
      params: { page: payload.page || 1, ...(payload.search ? { search: payload.search } : {}) },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  markPinAsUsed: (payload) => {
    const response = axios({
      url: `${url}/app/distributor/pin/mark-as-used`,
      method: "POST",
      data: JSON.stringify({
        pin_id: payload.pin_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },
};
export default FixedAgent;
